import request from "superagent"
// const CLOUDINARY_UPLOAD_PRESET = "zcx38izn"
const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/upload`

export const uploadPostImage = file => {
  // Gets file type. If video file has type property. If image file is base64 and needs to be split than get first element for type.
  const type = file.type ? file.type : file.split(";")[0]
  let cloudUploadPreset

  if (type.indexOf("image") !== -1) {
    cloudUploadPreset = process.env.REACT_APP_CLOUD_IMAGE_UPLOAD
  }

  if (type.indexOf("video") !== -1) {
    cloudUploadPreset = process.env.REACT_APP_CLOUD_VIDEO_UPLOAD
  }

  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      request
        .post(CLOUDINARY_UPLOAD_URL)
        .set("X-Requested-With", "XMLHttpRequest")
        .field("upload_preset", cloudUploadPreset)
        .field("file", file)
        .then(response => {
          if (response.body.secure_url !== "") {
            resolve(response.body)
          } else {
            reject(response.body)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
}



// WEBPACK FOOTER //
// ./src/actions/cloudinary.js